module.exports = __webpack_public_path__ + "static/media/logo.806d9d86.png";